import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import parse from 'html-react-parser';
import { useState } from 'react';
import { useSetContentMutation } from '../store';
import ManagementPanel from './shared/ManagementPanel';

export default function Title({ data, value }) {

    let { text, hint, video } = data?.content || {};
    const isEditable = !!data?.content;

    text = text || value;

    const [updateData] = useSetContentMutation();

    const [isEditMode, setIsEditMode] = useState(false);
    const [contextTitle, setContextTitle] = useState(text || '');

    const handleEdit = () => {
        const editorDataProcessed = contextTitle
            .replaceAll('</p><p>', '<br/>')
            .replaceAll('<p>', '')
            .replaceAll('</p>', '');

        setContextTitle(editorDataProcessed);
        setIsEditMode(!isEditMode);
    };

    const handleSave = () => {
        setIsEditMode(false);

        const editorDataProcessed = contextTitle
            .replaceAll('</p><p>', '<br/>')
            .replaceAll('<p>', '')
            .replaceAll('</p>', '');

        let updateContent = {
            ...data,
            content: {
                hint: hint,
                video: video,
                text: editorDataProcessed
            }
        };

        setContextTitle(editorDataProcessed);
        updateData(updateContent);
    };

    const handleReset = () => {
        setIsEditMode(false);
        setContextTitle(text);
    };

    const editContent = <div>
        <CKEditor
            config={{
                removePlugins: ['Title', 'MediaEmbedToolbar', 'Markdown'],
                toolbar: []
            }}
            editor={Editor.Editor}
            data={contextTitle}
            onChange={(_event, editor) => setContextTitle(editor.getData())}
        />
    </div>

    const viewVideoContent = video && <div className="extra-title">
        <div>
            <video autoPlay loop muted src={video} />
            {hint && <div className="video-text">{hint}</div>}
        </div>
    </div>;

    return (
        <div>
            {viewVideoContent}
            <div className="title">
                <div className="container">
                    {isEditable && <ManagementPanel handleEdit={handleEdit} handleSave={handleSave} handleReset={handleReset} />}
                    {isEditMode && editContent}
                    {!isEditMode && parse(text || '')}
                </div>
            </div>
        </div>
    )
};